import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[numericOnly]'
})
export class NumericOnlyDirective {

    @HostListener('keypress', ['$event'])
    onKeyPress(event: KeyboardEvent) {
        // Permetti i tasti di controllo (backspace, delete, tab, escape, enter, etc.)
        if ([8, 9, 27, 13, 46].indexOf(event.keyCode) !== -1 ||
            // Permetti Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
            (event.keyCode === 65 && event.ctrlKey === true) ||
            (event.keyCode === 67 && event.ctrlKey === true) ||
            (event.keyCode === 86 && event.ctrlKey === true) ||
            (event.keyCode === 88 && event.ctrlKey === true)) {
            return;
        }

        // Assicurati che sia un numero
        const pattern = /[0-9]/;
        const inputChar = String.fromCharCode(event.charCode);

        if (!pattern.test(inputChar)) {
            event.preventDefault();
        }
    }

    @HostListener('input', ['$event'])
    onInput(event: any) {
        // Limita a 8 caratteri numerici
        const originalValue = event.target.value;

        // Rimuovi tutti i caratteri non numerici
        const numericValue = originalValue.replace(/[^0-9]/g, '');

        // Limita a 8 caratteri
        const finalValue = numericValue.length > 8 ? numericValue.slice(0, 8) : numericValue;

        // Solo se il valore è effettivamente cambiato, aggiornalo
        if (originalValue !== finalValue) {
            event.target.value = finalValue;
            // Trigger change event per aggiornare il FormControl solo se necessario
            event.target.dispatchEvent(new Event('input', { bubbles: true }));
        }
    }

    @HostListener('paste', ['$event'])
    onPaste(event: ClipboardEvent) {
        event.preventDefault();

        // Ottieni il testo incollato
        const pastedText = event.clipboardData.getData('text') || '';

        // Mantieni solo i numeri e limita a 8 caratteri
        const numericText = pastedText.replace(/[^0-9]/g, '').slice(0, 8);

        // Imposta il valore nel campo
        const target = event.target as HTMLInputElement;
        target.value = numericText;

        // Trigger input event per aggiornare il FormControl
        target.dispatchEvent(new Event('input', { bubbles: true }));
    }
}